
  function handleScroll(slidesContainer) {
    const slideWidth = slidesContainer.offsetWidth;
    const scrollPosition = slidesContainer.scrollLeft + 5;
    const thumbnails = slidesContainer.nextElementSibling.querySelectorAll('.gallery-slider--thumbnail'); // Locate thumbnails after SlidesCon
    
    if (slidesContainer) {
      // Calculate the index based on the scroll position
      const index = Math.floor(scrollPosition / slideWidth) + 1;

     // pauseGalleryMedia();
      
      for (var i = 0; i < thumbnails.length; i++) {
        thumbnails[i].classList.remove("active");
    
        // Check if the thumbnail's data-slide-index matches the provided slideIndex
        if (thumbnails[i].getAttribute('data-slide-index') == index) {
          thumbnails[i].classList.add("active");
        }
      }    
    }  
  }
  
  // Add scroll event listeners to all slidesContainers
  const slidesContainers = document.querySelectorAll('.mobile-view-carousel.card-product--image-wrapper #SlidesCon');
  slidesContainers.forEach(slidesContainer => {
    slidesContainer.addEventListener('scroll', function() {
      handleScroll(slidesContainer); // Call handleScroll function for each container
    });
  
    // Initially trigger handleScroll to set the active state based on the initial scroll position
    handleScroll(slidesContainer);
  });

